module.exports = __webpack_public_path__ + "static/img/demo_user2.59e6f5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/placeholders/demo_user2.png
// module id = iSRV
// module chunks = 31